export default __webpack_public_path__ + "static/rpa-acce966203020ac2198569d9e787e5ff.svg";